import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import styles from './CheckBox.module.scss';

const CheckBox = ({ name, checked, onChange, children, className }) => (
  <span className={classnames(styles.root, className)}>
    <input
      type="checkbox"
      name={name}
      className={styles.checkbox}
      checked={checked}
      onChange={(event) => onChange && onChange(event)}
    />
    <span className={styles.checkboxContent}>{children}</span>
    <span className={styles.checkMark} />
  </span>
);

CheckBox.propTypes = {
  name: PropTypes.string,
  className: PropTypes.string,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  children: PropTypes.node
};

CheckBox.defaultProps = {
  name: null,
  className: null,
  checked: false,
  onChange: null,
  children: null
};

export { CheckBox };
